import { render, staticRenderFns } from "./addOffer.vue?vue&type=template&id=5bf3c37e&scoped=true"
import script from "./addOffer.vue?vue&type=script&lang=js"
export * from "./addOffer.vue?vue&type=script&lang=js"
import style0 from "./addOffer.vue?vue&type=style&index=0&id=5bf3c37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3c37e",
  null
  
)

export default component.exports